document.addEventListener('DOMContentLoaded', function() {

  var params = new URLSearchParams(window.location.search);
  var hasCond = document.querySelectorAll('.cond-btn').length > 0;

  var condUi = document.getElementById('cond-ui');
  var condGrid = document.getElementById('cond-grid');
  var condDesc = document.getElementById('cond-desc');
  var condButtons = document.getElementById('cond-buttons');

  if (hasCond) {
    var condText = document.querySelector('#cond-grid #cond-text');
    if (condText) {
      condText.style.display = 'block';
      condText.style.gridColumn = '1 / -1';
      document.querySelector('.collection--description').insertBefore(condText, condUi);
    }

    if (condUi) condUi.style.display = 'block';
    if (condGrid) condGrid.style.display = 'grid';
    if (condDesc) condDesc.style.display = 'none';
    if (condButtons) condButtons.style.display = 'flex';


    var selectedTags = params.get('selected_tags');
    var isResultPage = window.location.pathname.split('/').length > 3;

    if (selectedTags && !isResultPage) {
      var tagList = selectedTags.split(',');
      document.querySelectorAll('.cond-btn').forEach(function(btn) {
        if (tagList.indexOf(btn.getAttribute('data-tag')) !== -1) {
          btn.classList.add('selected');
        }
      });
    }

    var note = params.get('filter_note');
    if (note) {
      var el = document.getElementById('cond-filter-note');
      el.textContent = note;
      el.style.display = 'block';
    }

    document.querySelectorAll('.cond-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        this.classList.toggle('selected');
        document.getElementById('cond-filter-note').style.display = 'none';
      });
    });
  }

  window.applyCondFilter = function(collectionHandle) {
    var selected = document.querySelectorAll('.cond-btn.selected');
    if (selected.length === 0) {
      var el = document.getElementById('cond-filter-note');
      el.textContent = '条件を選択してください。';
      el.style.display = 'block';
      return;
    }
    var labels = [];
    var parts = [];
    var tagNames = [];
    selected.forEach(function(btn) {
      labels.push('「' + btn.textContent.trim() + '」');
      var t = btn.getAttribute('data-tag');
      tagNames.push(t);
      t.split(' ').forEach(function(tag) {
        if (tag) parts.push(encodeURIComponent(tag));
      });
    });
    var labelParam = encodeURIComponent(labels.join('') + 'に一致する商品は見つかりませんでした。');
    var tagsParam = encodeURIComponent(tagNames.join(','));
    window.location.href = '/collections/' + collectionHandle + '/' + parts.join('+') + '?filter_note=' + labelParam + '&selected_tags=' + tagsParam;
  };

  window.resetCondFilter = function() {
    document.querySelectorAll('.cond-btn.selected').forEach(function(btn) {
      btn.classList.remove('selected');
    });
    document.getElementById('cond-filter-note').style.display = 'none';
  };

});
